import { useFormContext, useWatch } from "react-hook-form"
import { FormField, FormItem, FormMessage } from "~/shadcn/ui/form"
import { Select } from "~/ui/Select"
import { SearchValues } from "~/screens/casting/data/searchSchema"
import { languageOptions } from "~/common/enums"

const FIELD_NAME = "influencerLanguages"

export const InfluencerLanguageFilter = () => {
  const form = useFormContext<SearchValues>()

  const selecteLanguages =
    useWatch({
      control: form.control,
      name: FIELD_NAME,
    }) || []

  return (
    <div className="flex-1">
      <FormField
        control={form.control}
        name={FIELD_NAME}
        render={({ field }) => (
          <FormItem>
            <Select
              options={languageOptions}
              value={languageOptions.filter((option) =>
                selecteLanguages.includes(option.value)
              )}
              onChange={(options) => {
                field.onChange(options.map((option) => option.value))
              }}
              placeholder="Languages"
              isMulti
            />
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
